import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Table, Modal } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import demandIcon from '../../assets/images/icons/demand_icon.svg';
import { DatePicker, Space } from 'antd';
import EditIcon from '../../assets/images/icons/edit.svg';
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';


function resetFormView() { };

const data = [
    {
        key: '1',
        id: 221530,
        name: 'Bidcube-TH-IA-Banner-225100',
        sspslist: 'None',
    },
    {
        key: '2',
        id: 221531,
        name: 'Bidcube-TH-IA-Banner-225101',
        sspslist: 'None',
    },
];

const FifthForm = ({ handlePageViewChange }) => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]); // To track selected rows
    const [enabledInputs, setEnabledInputs] = useState([]); // To track which rows have enabled inputs

    const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
    };

    // Determine if "Select All" checkbox should be checked or indeterminate
    const isIndeterminate = selectedRowKeys.length > 0 && selectedRowKeys.length < data.length;
    const isCheckAll = selectedRowKeys.length === data.length;

    const handleCheckboxChange = (checked, record) => {
        if (checked) {
            setSelectedRowKeys([...selectedRowKeys, record.key]);
            setEnabledInputs([...enabledInputs, record.key]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((key) => key !== record.key));
            setEnabledInputs(enabledInputs.filter((key) => key !== record.key));
        }
    };

    const columns = [
        {
            title: (
                <Checkbox
                    className='table_checkbox_d2'
                    indeterminate={isIndeterminate}
                    checked={isCheckAll}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        const allKeys = data.map((record) => record.key); // Assuming each data item has a unique `key`
                        setSelectedRowKeys(checked ? allKeys : []);
                        setEnabledInputs(checked ? allKeys : []); // Enable all inputs if all rows are selected
                    }}
                />
            ),
            dataIndex: 'checkbox',
            width: 30,
            fixed: 'left',
            render: (text, record) => (
                <Checkbox
                    className='table_checkbox_d2'
                    checked={selectedRowKeys.includes(record.key)}
                    onChange={(e) => handleCheckboxChange(e.target.checked, record)}
                />
            ),
        },
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
            render: (text, record) => <div className="text_dark_800">{record.id}</div>,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            render: (text, record) => <div className="text_dark">{record.name}</div>,
        },
        {
            title: 'SSPs list',
            dataIndex: 'sspslist',
            render: (text, record) => (
                <div>
                    <Input className='form_control px-3' disabled={!enabledInputs.includes(record.key)} />
                </div>
            ),
        },
    ];

    // Pagination
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const totalItems = data.length;

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    const onChangedate = (date, dateString) => {
        console.log(date, dateString);
    };

    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState(data);
    const [loading, setLoading] = useState(true);

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> GAM
                            </Link>
                        </li>
                        <li>Campaign</li>
                        <li className="primary">New Campaign</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }} />
                        <h1 className="heading"> Create Campaign </h1>
                    </div>
                    <div className='li_tabs_designs'>
                        <ul>
                            <li className='active_li_tab completed_li_tab'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 5.625V6.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 13.125V14.375" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Budget
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1.875 14.375V12.5859C1.875 8.09375 5.48437 4.39062 9.96875 4.375C11.0384 4.37089 12.0983 4.57801 13.0877 4.98449C14.077 5.39096 14.9764 5.98879 15.7342 6.74368C16.492 7.49857 17.0933 8.39565 17.5035 9.38346C17.9138 10.3713 18.125 11.4304 18.125 12.5V14.375C18.125 14.5408 18.0592 14.6997 17.9419 14.8169C17.8247 14.9342 17.6658 15 17.5 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 4.375V6.875" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.14844 10.3984L4.57031 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.8516 10.3984L15.4297 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.07812 15L13.4219 8.03906" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Optimization
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85787 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 14.1421 5.85787 17.5 10 17.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.002 14.5C12.4872 14.5 14.502 12.4853 14.502 10C14.502 7.51472 12.4872 5.5 10.002 5.5C7.51667 5.5 5.50195 7.51472 5.50195 10C5.50195 12.4853 7.51667 14.5 10.002 14.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Targeting
                            </li>
                            {/* <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2 3.73383V8.43381H6.69998" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.96616 12.3505C4.47406 13.7921 5.43673 15.0296 6.70911 15.8765C7.98149 16.7235 9.49465 17.1339 11.0206 17.0461C12.5466 16.9583 14.0026 16.3769 15.1694 15.3896C16.3362 14.4023 17.1506 13.0625 17.4897 11.5721C17.8289 10.0817 17.6745 8.52151 17.0498 7.12651C16.4251 5.73151 15.364 4.57732 14.0263 3.83783C12.6886 3.09834 11.1469 2.81363 9.6333 3.02658C8.11973 3.23953 6.71636 3.93861 5.63465 5.01849L2 8.43381" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Retargeting
                            </li> */}
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.4444 3H4.55556C3.69645 3 3 3.69645 3 4.55556V15.4444C3 16.3036 3.69645 17 4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.3036 3 15.4444 3Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.27799 8.44444C7.92233 8.44444 8.44466 7.92211 8.44466 7.27778C8.44466 6.63345 7.92233 6.11111 7.27799 6.11111C6.63366 6.11111 6.11133 6.63345 6.11133 7.27778C6.11133 7.92211 6.63366 8.44444 7.27799 8.44444Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9991 12.3333L13.1102 8.44444L4.55469 17" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Ads
                            </li>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.3618 8.85433L5.98865 3.17957C5.78818 3.06257 5.56089 3.00066 5.3294 3C5.09791 2.99935 4.87028 3.05997 4.66916 3.17583C4.46805 3.2917 4.30045 3.45877 4.18306 3.66042C4.06566 3.86207 4.00254 4.09128 4 4.32524L4 15.6748C4.00254 15.9087 4.06566 16.1379 4.18305 16.3396C4.30045 16.5412 4.46805 16.7083 4.66916 16.8242C4.87028 16.94 5.09791 17.0007 5.3294 17C5.56089 16.9993 5.78818 16.9374 5.98865 16.8204L15.3618 11.1457C15.5566 11.0262 15.7177 10.8581 15.8295 10.6574C15.9413 10.4567 16 10.2303 16 10C16 9.7697 15.9413 9.54329 15.8295 9.34262C15.7177 9.14194 15.5566 8.97377 15.3618 8.85433V8.85433Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Aniview
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Basic Info</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">Name *  </label>
                                                <Input className='form_control basic' placeholder='Ad Source Name' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Advertiser * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group hide_caret_after_select_value">
                                                        <label className="form_label">Creative Type *</label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                        <label className="form_label">Source Type* </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group hide_caret_after_select_value">
                                                        <label className="form_label">Accounting Fee *</label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                        <label className="form_label">Status * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                        <label className="form_label">Owner Type *</label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                        <label className="form_label">Environment * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>TPP</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">TPP Auth Credentials * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">TPP Entity ID * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Business Model</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Gross Rate ($) * </label>
                                                <Input className='form_control basic' placeholder='0' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Payment Model</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Revenue Model * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div >
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Back </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                    </div>
                </div >
            </div >
        </>
    )
}

export default FifthForm
